<form [formGroup]="contactForm" (ngSubmit)="onSubmitForm()"
      class="md:bg-white md:rounded-3xl md:py-10 md:px-12 md:shadow-lg md:shadow-neutral-100">
  <div class="flex flex-col items-start space-y-0.5 mb-3.5">
    @let isEmailInvalid = f.email.touched && f.email.invalid;
    <label for="email" class="text-sm font-medium">{{ 'CONTACT.FORM.EMAIL' | translate }}</label>
    <input type="text" name="email" id="email" placeholder="{{ 'CONTACT.FORM.EMAIL_PLACEHOLDER' | translate }}"
           formControlName="email" autocomplete="on"
           class="w-full px-4 py-2.5 border border-gray-300 rounded-lg
           placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-main-400
           focus:border-transparent transition-all duration-200"
           [class.border-red-500]="isEmailInvalid"
           [class.focus:ring-red-500]="isEmailInvalid">
    @if (f.email.touched && f.email.invalid) {
      <div class="text-sm text-red-500 font-medium">{{ 'CONTACT.FORM.ERROR.EMAIL' | translate }}</div>
    }
  </div>

  <div class="grid md:grid-cols-2 md:gap-2.5 md:mb-3.5">
    <div class="flex flex-col space-y-0.5 mb-3.5 md:mb-0">
      @let isFullNameInvalid = f.fullname.touched && f.fullname.invalid;
      <label for="fullname" class="text-sm font-medium">{{ 'CONTACT.FORM.FULLNAME' | translate }}</label>
      <input type="text" name="fullname" id="fullname"
             placeholder="{{ 'CONTACT.FORM.FULLNAME_PLACEHOLDER' | translate }}" formControlName="fullname"
             class="w-full px-4 py-2.5 border border-gray-300 rounded-lg
           placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-main-400
           focus:border-transparent transition-all duration-200"
             [class.border-red-500]="isFullNameInvalid"
             [class.focus:ring-red-500]="isFullNameInvalid">
      @if (isFullNameInvalid) {
        <div class="text-sm text-red-500 font-medium">{{ 'CONTACT.FORM.ERROR.FULLNAME' | translate }}</div>
      }
    </div>

    <div class="flex flex-col space-y-0.5 mb-3.5 md:mb-0">
      @let isPhoneNumberInvalid = f.phone.touched && f.phone.invalid;
      <label for="phoner" class="text-sm font-medium">{{ 'CONTACT.FORM.PHONE' | translate }}</label>
      <input type="text" name="phone" id="phoner"
             placeholder="{{ 'CONTACT.FORM.PHONE_PLACEHOLDER' | translate }}"
             formControlName="phone" autocomplete="phone"
             class="w-full px-4 py-2.5 border border-gray-300 rounded-lg
           placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-main-400
           focus:border-transparent transition-all duration-200"
             [class.border-red-500]="isPhoneNumberInvalid"
             [class.focus:ring-red-500]="isPhoneNumberInvalid">
      @if (isPhoneNumberInvalid) {
        <div class="text-sm text-red-500 font-medium">{{ 'CONTACT.FORM.ERROR.PHONE' | translate }}</div>
      }
    </div>
  </div>

  <div class="flex flex-col space-y-0.5 mb-3.5">
    @let isObjectInvalid = f.object.touched && f.object.invalid;
    <label for="object" class="text-sm font-medium">{{ 'CONTACT.FORM.OBJECT' | translate }}</label>
    <input type="text" name="object" id="object" placeholder="{{ 'CONTACT.FORM.OBJECT_PLACEHOLDER' | translate }}"
           formControlName="object"
           class="w-full px-4 py-2.5 border border-gray-300 rounded-lg
           placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-main-400
           focus:border-transparent transition-all duration-200"
           [class.border-red-500]="isObjectInvalid"
           [class.focus:ring-red-500]="isObjectInvalid">
    @if (isObjectInvalid) {
      <div class="text-sm text-red-500 font-medium">{{ 'CONTACT.FORM.ERROR.OBJECT' | translate }}</div>
    }
  </div>

  <div class="flex flex-col space-y-0.5 mb-3.5">
    @let isMessageInvalid = f.message.touched && f.message.invalid;
    <label for="message" class="text-sm font-medium">{{ 'CONTACT.FORM.MESSAGE' | translate }}</label>
    <textarea name="message" id="message" cols="30" rows="4"
              placeholder="{{ 'CONTACT.FORM.MESSAGE_PLACEHOLDER' | translate }}"
              formControlName="message"
              class="w-full px-4 py-2.5 border border-gray-300 rounded-lg placeholder-gray-400
              focus:outline-none focus:ring-2 focus:ring-main-400 focus:border-transparent transition-all duration-200"
              [class.border-red-500]="isMessageInvalid"
              [class.focus:ring-red-500]="isMessageInvalid"></textarea>
    @if (isMessageInvalid) {
      <div class="text-sm text-red-500 font-medium">{{ 'CONTACT.FORM.ERROR.MESSAGE' | translate }}</div>
    }
  </div>

  <div class="mb-5">
    @let isRecaptchaInvalid = f.recaptcha.touched && f.recaptcha.invalid;
    <re-captcha #recaptcha (resolved)="onRecaptchaResolved($event)"
                [siteKey]="recaptchaSiteKey"/>
    @if (isRecaptchaInvalid) {
      <div class="text-red-500 text-sm">{{ 'CONTACT.FORM.ERROR.RECAPTCHA' | translate }}</div>
    }
  </div>

  <button type="submit"
          class="w-full py-3 text-sm bg-main-500 hover:bg-main-400 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 disabled:opacity-50"
          [disabled]="!contactForm.valid || loading()" [class.cursor-not-allowed]="!contactForm.valid || loading()">
    @if (loading()) {
      <div class="flex items-center gap-1.5">
        {{ 'LOADING' | translate }}
        <lucide-icon [img]="LoaderCircle" [size]="22" class="animate-spin" aria-hidden="true"/>
      </div>
    } @else {
      {{ 'CONTACT.FORM.SEND' | translate }}
    }
  </button>
</form>
